import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React, { useState } from 'react';

interface IProps {
  values: { gte: string | null; lte: string | null };
  onChange: (s: Date | null, e: Date | null) => void;
}

function DateRangeRow({ onChange, values }: IProps) {
  const [startDate, setStartDate] = useState<Date | null>(
    values?.gte ? new Date(values.gte) : null,
  );
  const [endDate, setEndDate] = useState<Date | null>(values?.lte ? new Date(values.lte) : null);

  return (
    <div className="flex items-center w-full gap-8">
      <DatePicker
        className="w-full"
        value={startDate}
        onChange={(v) => {
          console.log(v);
          if (!v) return;
          setStartDate(v);
          onChange(v, endDate);
        }}
        maxDate={endDate ? endDate : new Date()}
        minDate={new Date(Date.UTC(1900, 0, 1))}
      />
      {' - '}
      <DatePicker
        className="w-full"
        value={endDate}
        onChange={(v) => {
          if (!v) return;
          setEndDate(v);
          onChange(startDate, v);
        }}
        maxDate={new Date()}
        minDate={startDate ? startDate : new Date(Date.UTC(1900, 0, 1))}
      />
    </div>
  );
}

export default DateRangeRow;
